import { List, Map } from 'immutable';

import { ISomeEffect } from '../types';

import { effectSubscriber, queueEffectMiddleware } from './effects';
import { exportModule } from './module';
import { state } from './state';

export const composeAppCoreModule = (effects: Map<string, ISomeEffect>) =>
  exportModule({
    middleware: List([queueEffectMiddleware]),
    state,
    subscribers: List.of(effectSubscriber(effects))
  });
